export default __webpack_public_path__ + "static/fighting-coronavirus-innovations-opaque-657eac201019983f54517a0e76cb0dcf.png";